
export const WikipediaApi = {
  /**
   * Loads an Wikipedia article for the given query string.
   *
   * @param  {String} queryString Query string to search article by
   * @return {Promise}            Promise resolving to the API response JSON
   */
  loadArticle (queryString) {
    const url = new URL('https://de.wikipedia.org/w/api.php?');
    const params = {
      format: 'json',
      action: 'query',
      prop: 'extracts|pageimages|images',
      exintro: '',
      explaintext: '',
      // prop: 'pageimages|extracts|images',
      titles: queryString,
      origin: '*'
    };
    Object.keys(params).forEach(
      key => url.searchParams.append(key, params[key]));

    const promise = new Promise(function (resolve, reject) {
      fetch(url)
        .then((resp) => {
          return resp.json()
        })
        .then((respJson) => {
          if (respJson.query.pages &&
              Object.keys(respJson.query.pages).length > 0) {
            resolve(respJson.query.pages);
          } else {
            reject(Error('No data (articles) found'));
          }
        });
    });

    return promise;
  },

  /**
   * Loads an Wikipedia image with the given image name.
   *
   * @param  {String} imageName Name of the image file
   * @return {Promise}          Promise resolving to the API response JSON
   */
  loadImage (imageName) {
    const url = new URL('https://de.wikipedia.org/w/api.php?');
    let params = {
      format: 'json',
      action: 'query',
      titles: 'Image:' + imageName,
      prop: 'imageinfo',
      iiprop: 'url',
      origin: '*'
    };
    Object.keys(params).forEach(
      key => url.searchParams.append(key, params[key]));

    const promise = new Promise(function (resolve, reject) {
      fetch(url)
        .then((resp) => {
          return resp.json();
        })
        .then((respJson) => {
          if (respJson.query.pages &&
              Object.keys(respJson.query.pages).length > 0) {
            resolve(respJson.query.pages);
          } else {
            reject(Error('No data (images) found'));
          }
        })
    });

    return promise;
  },

  /**
   * Returns a radom image of a Wikipedia page described in its JSON
   *
   * @param  {Object} wikiPage JSON of a Wikipedia page
   * @return {String}          Filename
   */
  getRandomImageName (wikiPage) {
    var imgs = wikiPage.images;
    if (!imgs) {
      return null;
    }
    var randomImage = imgs[Math.floor(Math.random() * imgs.length)];
    var cleanedName = randomImage.title.replace('Datei:', '');

    var safeCnt = 0;
    while (this.isGenericWikipediaImage(cleanedName) && safeCnt < imgs.length) {
      randomImage = imgs[Math.floor(Math.random() * imgs.length)];
      cleanedName = randomImage.title.replace('Datei:', '');

      safeCnt++;
    }

    if (safeCnt === imgs.length) {
      return null;
    }

    return cleanedName;
  },

  /**
   * Detects if the given image name belongs to a generic wikipedia image, which
   * is used in several articles (wo/ a meaning for the article topic).
   *
   * @param  {String}  imageName The image name
   * @return {Boolean}           Generic image yes/no (true/false)
   */
  isGenericWikipediaImage (imageName) {
    var genericImgs = [
      '_gray.svg',
      'icon',
      'Commons-logo.svg',
      'Ambox',
      'Text_document_with_red_question_mark.svg',
      'Question_book-new.svg',
      'Canadese_kano',
      'Wiki_letter_',
      'Edit-clear.svg',
      'WPanthroponymy',
      'Compass_rose_pale',
      'Us-actor.svg',
      'voting_box',
      'Crystal_',
      'transportation_inv',
      'arrow.svg',
      'Quill_and_ink-US.svg',
      'Decrease2.svg',
      'Rating-',
      'template',
      'Nuvola_apps_',
      'Mergefrom.svg',
      'Portal-',
      'Translation_to_',
      'School.svg',
      'arrow',
      'Symbol_',
      'stub',
      'Unbalanced_scales.svg',
      '-logo.',
      'P_vip.svg',
      'Books-aj.svg_aj_ashton_01.svg',
      'Film',
      'Gnome-',
      'cap.svg',
      'Missing',
      'silhouette',
      'Star_empty.svg',
      'Music_film_clapperboard.svg',
      'IPA_Unicode',
      'symbol',
      '_highlighting_',
      'pictogram',
      'Pictogram_voting_info.svg',
      'Red_pog.svg',
      '_medal_with_cup',
      '_balloon',
      'Feature',
      'Aiga_',
      'Disambig',
      'Reddot',
      'Germany_adm_location_map',
      'Germany_adm_location_map.svg'
    ];

    var isGeneric = false;
    for (var i = 0; i < genericImgs.length; i++) {
      // console.log(genericImgs[i]);
      if (imageName.indexOf(genericImgs[i]) !== -1) {
        isGeneric = true;
      }
    }

    return isGeneric;
  }
}



// WEBPACK FOOTER //
// ./app/WikipediaApi.js